<template>
  <div class="animated fadeIn">
    <div class="card">
      <div class="card-header">
        <span v-if="mData.viewMode == 'create'">{{aLang.c_create}} {{aLang.eg_title}}</span>
        <span v-if="mData.viewMode == 'update'">{{aLang.c_update}} {{aLang.eg_title}}</span>
        <span v-if="mData.viewMode == 'detail'">{{aLang.c_detail}} {{aLang.eg_title}}</span>
        <div class="card-header-actions"></div>
      </div>
      <div class="card-body">
        <el-form
          :model="mData.dataForm"
          :rules="mData.validForm"
          ref="myForm"
          label-width="100%"
          label-position="top"
        >          

          <b-row>            
            <b-col md="6">
              <el-form-item :label="aLang.eg_object_evaluation" prop="loai">               
                <el-select
                  v-model="mData.dataForm.loai"
                  :placeholder="aLang.c_select"
                  :disabled="mData.viewMode == 'detail' || mData.viewMode == 'update'"
                  clearable
                  filterable
                >
                  <el-option
                    v-for="item in mData.dataDefault.loaiNhomTPDanhGia"
                    :key="item.code"
                    :label="item.text"
                    :value="item.code"
                  ></el-option>
                </el-select>
              </el-form-item>             
            </b-col>
            <b-col md="4">
              <el-form-item :label="aLang.eg_order" prop="thu_tu">
                <el-input
                  type="number"
                  v-model="mData.dataForm.thu_tu"
                  :disabled="mData.viewMode == 'detail'"
                  clearable
                ></el-input>
              </el-form-item>
            </b-col>
            <b-col md="2">
              <el-form-item :label="aLang.eg_hide" prop="thu_tu">
                <el-checkbox
                  v-model="mData.dataForm.an"
                  :disabled="mData.viewMode == 'detail'"
                ></el-checkbox>
              </el-form-item>
            </b-col>
          </b-row>
          <b-row>
            <b-col md="6">
              <el-form-item :label="aLang.eg_vietnamese_name" prop="ten.vi">
                <el-input
                  type="text"
                  v-model="mData.dataForm.ten.vi"
                  :disabled="mData.viewMode == 'detail'"
                  clearable
                ></el-input>
              </el-form-item>
            </b-col>
            <b-col md="6">
              <el-form-item :label="aLang.eg_english_name" prop="ten.en">
                <el-input
                  type="text"
                  v-model="mData.dataForm.ten.en"
                  :disabled="mData.viewMode == 'detail'"
                  clearable
                ></el-input>
              </el-form-item>           
            </b-col>   
          </b-row>              

          <el-form-item class="text-center mt-3">
            <el-button
              type="info"
              plain
              @click="fn_submitForm('create')"
              v-ladda
              v-if="mData.viewMode == 'create'"
            >{{aLang.c_create}}</el-button>

            <el-button
              type="info"
              plain
              @click="fn_submitForm('update')"
              v-ladda
              v-if="mData.viewMode == 'update'"
            >{{aLang.c_update}}</el-button>

            <el-button @click="fn_go()" type="info" plain>{{aLang.c_back}}</el-button>
          </el-form-item>
        </el-form>
      </div>
    </div>
  </div>
</template>

<script>
import LanguageService from "../../../service/LanguageService";
import DataService from "../../../service/DataService";
import MethodService from "../../../service/MethodService";
import NhomTPDanhGiaModel from "./NhomTPDanhGiaModel";
import NhomTPDanhGiaApi from "../../../moduleApi/NhomTPDanhGiaApi";

export default {
  data() {
    return {
      aLang: LanguageService.lang,
      aElement: MethodService.element,
      mData: {
        viewMode: "create",
        moduleName: "NhomTPDanhGia",
        dataDefault: {
          roles: DataService.rolesInForm,
          loaiNhomTPDanhGia: NhomTPDanhGiaModel.loaiNhomTPDanhGia
        },
        dataForm: MethodService.copyObject(NhomTPDanhGiaModel.dataForm),
        validForm: NhomTPDanhGiaModel.validForm,
        dialog: {}        
      }
    };
  },
  methods: {
    fn_submitForm(type) {
      this.$refs["myForm"].validate(async valid => {
        if (valid) {
          if (type == "create") {
            await NhomTPDanhGiaApi.create(this.mData.dataForm);
            this.fn_resetForm();
          }
          if (type == "update") {
            this.mData.dataForm.id = this.$router.currentRoute.params.id;
            await NhomTPDanhGiaApi.update(this.mData.dataForm);
            this.fn_go(-1);
          }
        } else {
          MethodService.stopLadda();
          return false;
        }
      });
    },
    fn_resetForm() {
      this.$refs["myForm"].resetFields();
    },
    fn_go() {
      this.$router.go(-1);
    },
    async fn_getDataById(id) {
      let res = await NhomTPDanhGiaApi.findById(id);
      this.mData.dataForm = res.result;      

    },
    async fn_initDataDefault() {    

    },   

    fn_formatterDate(row, column, cellValue, index) {
      return MethodService.formatDate(cellValue, "date");
    },

    fn_formatterDatetime(row, column, cellValue, index) {
      return MethodService.formatDate(cellValue, "datetime");
    },    
  },   
  created: function() { 
    this.fn_initDataDefault();
    if (
      this.$router.currentRoute.name ==
      "Admin-" + this.mData.moduleName + "-update"
    ) {
      this.mData.viewMode = "update";
    }
    if (
      this.$router.currentRoute.name ==
      "Admin-" + this.mData.moduleName + "-detail"
    ) {
      this.mData.viewMode = "detail";
    }
    if (this.$router.currentRoute.params.id) {
      this.fn_getDataById(this.$router.currentRoute.params.id);
    }
  },
  mounted: function() {}
};
</script>